import { render, staticRenderFns } from "./SimilarityChip.vue?vue&type=template&id=a293b13a&scoped=true&"
import script from "./SimilarityChip.vue?vue&type=script&lang=js&"
export * from "./SimilarityChip.vue?vue&type=script&lang=js&"
import style0 from "./SimilarityChip.vue?vue&type=style&index=0&id=a293b13a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a293b13a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
